export const defaultStyle = {
    wrapper: "relative bg-red",
    container: "section-wrapper flex flex-col items-center gap-8 py-8 md:py-10 lg:py-12 xlg:pt-[60px] xlg:pb-[117px]",
    title: "headline2 text-white title-shadow text-center",
    subtitle: "body-l font-medium text-white text-center",
    anchors: "w-full grid grid-cols-1 items-strech gap-4 md:grid-cols-3",
    anchor: "button-secondary px-3 py-[14px] font-semibold",
}
